import dynamic from 'next/dynamic';
import {ProductCardProps} from '@/_application/modules/products/components/cards/card.types';

const Configurable = dynamic(
    () => import('@/_application/modules/products/components/cards/configurable').then(m => m.Configurable),
    {ssr: false},
);
const Simple = dynamic(() => import('@/_application/modules/products/components/cards/simple').then(m => m.Simple), {
    ssr: false,
});
const MAP_PRODUCT_TO_CARD: Record<string, any> = {
    ConfigurableProduct: Configurable,
    SimpleProduct: Simple,
};

export const ProductCard: React.FC<ProductCardProps> = ({product, className, ...props}) => {
    const Component =
        product?.__typename && MAP_PRODUCT_TO_CARD[product?.__typename]
            ? MAP_PRODUCT_TO_CARD[product?.__typename]
            : Simple;
    return <Component product={product} {...props} className={className} />;
};
